import React from 'react';
import { Textarea as ChakraTextarea, TextareaProps as ChakraTextareaProps } from '@chakra-ui/react';
import { NormalizedInput } from './Input/NormalizedInput';
import { normalizeTextAreaChangeEvent } from '../../helpers/normalizeTextAreaChangeEvent';

export default function Textarea(props: ChakraTextareaProps & NormalizedInput) {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!props.onChange) return;

    if (!props.shouldNormalize) {
      props.onChange(e);
      return;
    }

    props.onChange(normalizeTextAreaChangeEvent(e));
  };

  return <ChakraTextarea {...props} onChange={handleChange} />;
}
